module.exports = __webpack_public_path__ + "static/media/custom-reports.f699a4b0.svg";